import { types } from 'mobx-state-tree';


const LicenceBase = types
    .model('LicenceBase', {
        firstLicenceAge: types.number,
        
        driverTraining: types.maybeNull(types.number),
    });

export default LicenceBase;
